import React from "react";
import { Col, Row, Container, Progress } from 'reactstrap';

const Bmi = ({calculatedBmi}) => {
    
    let leftPosition = 0, fillColor='#1DBDD2';
    if(calculatedBmi < 18.5){
      leftPosition = '10%';
      fillColor='#1DBDD2';
    }
    else if(calculatedBmi >= 18.5 && calculatedBmi < 25) {
      leftPosition = '35%';
      fillColor='#3BC98D';
    }
    else if(calculatedBmi >= 25 && calculatedBmi < 30) {
      leftPosition = '61%';
      fillColor='#FF8D52';
    }
    else if(calculatedBmi >= 30) {
      leftPosition = '85%';
      fillColor='#FC4551';
    }

    return(
      <>
        <div className="bmi-progress-container mt-3">
          <h1 className="text-center mb-0">{calculatedBmi > 16 ? calculatedBmi : '--' }</h1>
          <h4 className="text-center mb-3">{ calculatedBmi > 16 ? 'CALCULATED BMI' : 'Add appropriate value'}</h4>
          <div className="position-relative">
            <svg style={{left:leftPosition}} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8.5" cy="8.5" r="8.5" fill={fillColor}/>
              <circle cx="8.5" cy="8.5" r="3.5" fill="white"/>
            </svg>
            <Progress multi className="bmi-progress">
              <Progress bar color="info" value={25} key={1} className="text-center">
              </Progress>
              <Progress bar color="success" value={25} key={2} />
              <Progress bar color="warning" value={25} key={4} />
              <Progress bar color="danger" value={25} key={3} />
            </Progress>
            <Row className="mt-3 bmi-lable">
              <Col className="text-center">Low</Col>
              <Col className="text-center">Optimal</Col>
              <Col className="text-center ps-0 pe-0">Overweight</Col>
              <Col className="text-center">Obese</Col>
            </Row>
          </div>
        </div>
      </>
    )
}

export default Bmi